import React from "react"
export default function Whoops() {
    return (
        <div className="whoops-page">
            <h1>Whoopsy! There is nothing here!</h1>
        </div>
    )
}